import { Box, Checkbox, FormControlLabel, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ModalHeader from '../../../common/Header'
import '../../../../styles/Booking/TripSchedule.scss'
import CustomDatePicker from '../../../common/CustomDatePicker'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import TextBox from '../../../common/TextBox'
import DropDownV4 from '../../../common/DropDownV4'
import MButton from '../../../common/MButton'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import { amPmTypeList, autoIncreaseForAmtOpt, autoIncreaseForPreOpt, filterTrips, formatTime, hrList, minList, parseTime, runOptList, ValueTypeOpt, weeklyList } from '../../constant'
import { getCompanyAmenitiesAll, getTripsConfiguredDetailsList, updateShowAlert, updateTripSchedule } from '../../../../redux/Actions'
import { isEmpty, mergedArraySeparateObject, removeDuplicatesFromArray } from '../../../../Utils'
import TextBoxPlain from '../../../common/TextBoxPlain'

const TripSchedule = (props) => {
    const { onBack, trip, chartData, handleAfterBooking = () => { }, userDetails } = props

    const dispatch = useDispatch()
    const { subRoutesCity, amenitiesList } = useSelector((state) => state.common);
    const [filterValue, setFilterValue] = useState({
        from: [],
        to: [],
        fareType: [],
        ChartDate: dayjs(new Date()),
        StartDate: dayjs(new Date()),
        endDate: dayjs(new Date()),
        amenities: [],
        runs: [runOptList[0]],
        isActive: true,
        hasGST: false,
        nonRefundable: false,
        valueType: [ValueTypeOpt[0]],
        autoIncrease: [autoIncreaseForAmtOpt[0]],
        amount: [],
        isMon: false,
        isTue: false,
        isWed: false,
        isThur: false,
        isFri: false,
        isSat: false,
        isSun: false,
        hrs: '',
        min: '',
        amPm: ''
    })
    const [tableData, setTableData] = useState({
        origin: [],
        edit: []
    })
    const [filterOpt, setFilterOpt] = useState({
        fromCity: [],
        toCity: [],
        fareType: []
    })
    const checkList = [
        { name: 'Is Active', field: "isActive", value: 0 },
        { name: 'Has GST', field: "hasGST", value: 1 },
        { name: 'Non Refundable', field: "nonRefundable", value: 2 },

    ]

    const fareTypeFieldMap = {
        1: "SeaterLow",
        2: "SeaterHigh",
        3: "SlumberLow",
        4: "SlumberHigh",
        5: "SleeperLow",
        6: "SleeperHigh"
    };
    // compute from the exact array you map
    const fares =
        (filterValue?.fareType?.[0]?.id === 0 ? filterOpt?.fareType : filterValue?.fareType) || [];
    const many = fares.length > 1;
    const selectedFareTypes =
        filterValue?.fareType?.[0]?.id === 0
            ? filterOpt?.fareType || []
            : filterValue?.fareType || [];

    const tableCol = [
        { headerName: "From", field: "FromCityName", style: { textAlign: "left", width: "20%" } },
        { headerName: "To", field: "ToCityName", style: { textAlign: "left", width: "20%" } },
        ...(selectedFareTypes?.map(fare => ({
            headerName: fare.name,
            field: fareTypeFieldMap[fare.id],
            style: { textAlign: "right", width: "15%" }
        })) || [])
    ];

    useEffect(() => {
        if (!isEmpty(trip)) {
            const { hrsObj, minsObj, ampmObj } = parseTime(trip?.TripTime);
            setFilterValue((prev) => ({
                ...prev,
                ChartDate: dayjs(trip?.ChartDate, 'DD-MMM-YYYY'),
                StartDate: dayjs(trip?.ChartDate, 'DD-MMM-YYYY'),
                endDate: dayjs(trip?.ChartDate, 'DD-MMM-YYYY'),
                hrs: [hrsObj],
                min: [minsObj],
                amPm: [ampmObj]
            }))
        }
    }, [trip])
    useEffect(() => {
        if (Object.keys(chartData)?.length > 0 && (chartData.hasOwnProperty('ChartLayoutWithFare') && chartData.hasOwnProperty('BookingStatus'))) {
            let chartLayoutData = JSON.parse(chartData?.ChartLayoutWithFare)?.Table || []
            const fareList = []
            chartLayoutData.forEach((obj) => {
                if (obj.SeatTypeID == 1 || obj.SeatTypeID == 2 || obj.SeatTypeID == 3) {
                    if (obj.SeatTypeID == 1 && obj.IsAC == 0) {
                        fareList.push({ name: 'Seater NAC', id: 1 })
                    } else if (obj.SeatTypeID == 1 && obj.IsAC == 1) {
                        fareList.push({ name: 'Seater AC', id: 2 })
                    } else if (obj.SeatTypeID == 3 && obj.IsAC == 0) {
                        fareList.push({ name: 'SemiSleeper NAC', id: 3 })
                    } else if (obj.SeatTypeID == 3 && obj.IsAC == 1) {
                        fareList.push({ name: 'SemiSleeper AC', id: 4 })
                    } else if (obj.SeatTypeID == 2 && obj.IsAC == 0) {
                        fareList.push({ name: 'Sleeper NAC', id: 5 })
                    } else if (obj.SeatTypeID == 2 && obj.IsAC == 1) {
                        fareList.push({ name: 'Sleeper AC', id: 6 })
                    }
                }
            })
            let fareTypeList = removeDuplicatesFromArray(fareList, 'id')
            setFilterOpt((prev) => ({
                ...prev,
                fareType: fareTypeList
            }))
            setFilterValue((prev) => ({
                ...prev,
                fareType: fareTypeList?.length > 0 ? [fareTypeList[0]] : []
            }))
        }
    }, [chartData])
    useEffect(() => {
        dispatch(getCompanyAmenitiesAll())
    }, [])
    useEffect(() => {
        if (subRoutesCity?.length > 0) {
            let sortFromCity = subRoutesCity?.sort((a, b) => a.FromPos - b.FromPos)
            setFilterOpt((prev) => ({
                ...prev,
                fromCity: sortFromCity,
                toCity: subRoutesCity,
            }))
            setFilterValue((prev) => ({
                ...prev,
                from: subRoutesCity?.length > 0 ? [{ FromCityID: 0, FromCityName: 'All' }] : [],
                to: subRoutesCity?.length > 0 ? [{ ToCityID: 0, ToCityName: 'All' }] : []
            }))
        }
    }, [subRoutesCity])

    const handleFromCity = (val) => {
        let filterToCityList = subRoutesCity?.filter((obj) => obj.FromCityID === val?.[0]?.FromCityID || val?.[0]?.FromCityID === 0)
        let sortToCity = filterToCityList?.sort((a, b) => a.ToPos - b.ToPos)
        setFilterValue((prev) => ({
            ...prev,
            from: val,
            to: sortToCity?.length > 0 ? [{ ToCityID: 0, ToCityName: 'All' }] : []
        }))
        setFilterOpt((prev) => ({
            ...prev,
            toCity: sortToCity,
        }))
        resetTableData()

    }



    const handleConfiguredDetails = () => {
        if (filterValue?.from?.length === 0) {
            dispatch(updateShowAlert({ msg: 'Please Select From City', open: true, }));
            return
        }
        if (filterValue?.to?.length === 0) {
            dispatch(updateShowAlert({ msg: 'Please Select To City', open: true, }));
            return
        }
        resetTableData()
        const body = {
            UserID: userDetails?.UserID,
            CompanyID: userDetails?.CompanyID,
            TripID: trip?.TripID,
            ChartDate: dayjs(filterValue?.ChartDate).format('YYYY-MM-DD'),
            intFareType: 0,
        }
        dispatch(getTripsConfiguredDetailsList(body)).then((res) => {
            if (res?.status === 200) {
                let data = JSON.parse(res.data.APIMavenTripsConfiguredDetailsListResult)?.Table || []
                let originData = []
                let editData = []
                const selectedFrom = filterValue?.from?.map(f => f?.FromCityID) || [];
                const selectedTo = filterValue?.to?.map(t => t?.ToCityID) || [];
                if (selectedFrom.includes(0) && selectedTo.includes(0)) {
                    editData.push(...data);
                }
                else {
                    data.forEach(obj => {
                        const isFromMatch = selectedFrom.includes(0) || selectedFrom.includes(obj.FromCityID);
                        const isToMatch = selectedTo.includes(0) || selectedTo.includes(obj.ToCityID);
                        if (isFromMatch && isToMatch) {
                            editData.push(obj);
                        } else {
                            originData.push(obj);
                        }
                    });
                }
                setFilterValue((prev) => ({
                    ...prev, hasGST: data[0]?.HasSTax,
                    amenities: JSON.parse(res.data.APIMavenTripsConfiguredDetailsListResult)?.Table1
                }))
                setTableData({
                    origin: originData,
                    edit: editData
                })
            }
        })
    }

    const handleAutoIncrease = () => {
        const enteredAmounts = filterValue?.amount || {};

        if (
            Object.values(enteredAmounts).every(
                (val) => !val || val.toString().trim() === ""
            )
        ) {
            dispatch(
                updateShowAlert({
                    msg: "Please Enter Amount",
                    open: true,
                })
            );
            return;
        }

        const oldData = tableData?.edit || [];

        const newData = oldData.map((obj) => {
            let updatedObj = { ...obj };

            // loop over each fareType entered
            Object.entries(enteredAmounts).forEach(([fareTypeId, val]) => {
                const fareTypeField = fareTypeFieldMap[fareTypeId];
                if (!fareTypeField) return;

                const baseFare = obj[fareTypeField] || 0;
                let amount = 0;

                if (filterValue?.valueType?.[0]?.id === 0) {
                    // Fixed value
                    if (filterValue?.autoIncrease?.[0]?.id === 0) {
                        amount = baseFare + Number(val);
                    } else if (filterValue?.autoIncrease?.[0]?.id === 1) {
                        amount = Math.max(baseFare - Number(val), 0);
                    } else {
                        amount = Number(val);
                    }
                } else {
                    // Percentage
                    let perIncreaseAmt = (baseFare * Number(val)) / 100;
                    if (filterValue?.autoIncrease?.[0]?.id === 0) {
                        amount = baseFare + perIncreaseAmt;
                    } else {
                        amount = Math.max(baseFare - perIncreaseAmt, 0);
                    }
                }

                updatedObj[fareTypeField] = amount; // ✅ update the right field
            });

            return updatedObj;
        });

        setTableData((prev) => ({
            ...prev,
            edit: newData,
        }));
    };

    const handleFareAmount = (fromCity, toCity, field, amount) => {
        const oldData = tableData?.edit || [];

        const newData = oldData.map((obj) =>
            obj.FromCityID === fromCity && obj.ToCityID === toCity
                ? { ...obj, [field]: Number(amount) } // ✅ update correct field
                : obj
        );

        setTableData((prev) => ({
            ...prev,
            edit: newData,
        }));
    };

    const resetTableData = () => {
        setTableData({
            origin: [],
            edit: []
        })
    }
    const handleScheduleTrip = () => {
        let checkFareAmount = tableData?.edit?.filter((obj) => (obj.amount?.toString()?.trim() === ''))
        if (checkFareAmount?.length !== 0) {
            dispatch(
                updateShowAlert({
                    msg: 'Please Enter All Fare Amount',
                    open: true,
                })
            );
        } else {
            let tableObj = mergedArraySeparateObject(tableData?.edit || [])
            let timeStr = formatTime(filterValue?.hrs, filterValue?.min, filterValue?.amPm)
            const body = { details: `${userDetails?.UserID}|${trip?.TripID}|${timeStr}|${trip?.TripCode}|${tableData?.edit?.[0]?.Suffix || ''}|${trip.CompanyChartID}|${filterValue?.runs?.[0]?.value}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isMon : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isTue : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isWed : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isThur : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isFri : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isSat : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isSun : false}|${dayjs(filterValue?.StartDate).format('DD-MMM-YYYY')}|${dayjs(filterValue?.endDate).format('DD-MMM-YYYY')}|${tableObj?.FromCityID}|${tableObj?.ToCityID}|${tableObj?.SeaterLow}|${tableObj?.SeaterMedium}|${tableObj?.SeaterHigh}|${tableObj?.SlumberLow}|${tableObj?.SlumberMedium}|${tableObj?.SlumberHigh}|${tableObj?.SleeperLow}|${tableObj?.SleeperMedium}|${tableObj?.SleeperHigh}|${filterValue?.isActive}|${filterValue?.hasGST ? true : false}|${(filterValue?.amenities.map((obj) => (obj.AmenitiesTypeID))).join('^')}|${filterValue?.nonRefundable}|${tableObj.SuffixSubRoute}|${tableData?.edit?.[0]?.IsDynamicFareAllowed === 1}|||${tableData?.edit?.[0]?.IsOnlineSeatEdit === 1}|${userDetails?.UserID}|${userDetails?.TokenPassword}||||||||||||0|${trip.FromCityNameMain}|${trip?.ToCityNameMain}|${trip?.TripID}|${trip?.TripID}|${userDetails?.CompanyName}||||||false|0` }
            // const body = { details: `${userDetails?.UserID}|${trip?.TripID}|${trip?.TripTime}|${trip?.TripCode}|${tableData?.edit?.[0]?.Suffix || ''}|${trip.CompanyChartID}|${filterValue?.runs?.[0]?.value}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isMon : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isTue : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isWed : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isThur : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isFri : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isSat : false}|${filterValue?.runs?.[0]?.value === 3 ? filterValue?.isSun : false}|${dayjs(filterValue?.StartDate).format('DD-MMM-YYYY')}|${dayjs(filterValue?.endDate).format('DD-MMM-YYYY')}|${tableObj?.FromCityID}|${tableObj?.ToCityID}|${filterValue?.fareType?.[0]?.id === 1 ? tableObj?.amount : tableObj?.SeaterLow}|${tableObj?.SeaterMedium}|${filterValue?.fareType?.[0]?.id === 2 ? tableObj?.amount : tableObj?.SeaterHigh}|${filterValue?.fareType?.[0]?.id === 3 ? tableObj?.amount : tableObj?.SlumberLow}|${tableObj?.SlumberMedium}|${filterValue?.fareType?.[0]?.id === 4 ? tableObj?.amount : tableObj?.SlumberHigh}|${filterValue?.fareType?.[0]?.id === 5 ? tableObj?.amount : tableObj?.SleeperLow}|${tableObj?.SleeperMedium}|${filterValue?.fareType?.[0]?.id === 6 ? tableObj?.amount : tableObj?.SleeperHigh}|${filterValue?.isActive}|${filterValue?.hasGST ? true : false}|${(filterValue?.amenities.map((obj) => (obj.AmenitiesTypeID))).join('^')}|${filterValue?.nonRefundable}|${tableObj.SuffixSubRoute}|${tableData?.edit?.[0]?.IsDynamicFareAllowed === 1}|||${tableData?.edit?.[0]?.IsOnlineSeatEdit === 1}|${userDetails?.UserID}|${userDetails?.TokenPassword}||||||||||||0|${trip.FromCityNameMain}|${trip?.ToCityNameMain}|${trip?.TripID}|${trip?.TripID}|${userDetails?.CompanyName}||||||false|0` }
            dispatch(updateTripSchedule(body)).then((res) => {
                if (res?.trim() === '') {
                    dispatch(
                        updateShowAlert({
                            msg: 'Trip Schedule Successfully',
                            open: true,
                        })
                    );
                    handleAfterBooking()
                } else {
                    dispatch(
                        updateShowAlert({
                            msg: res,
                            open: true,
                        })
                    );
                }

            })
        }
    }
    return (
        <Box>
            <ModalHeader headerText={`Trip Schedule`} subHeader={trip.ChartName} showBackArrow={true} onBackClick={() => { onBack() }} />
            <Box className='tripSchedule'>
                <Box className='filter-section'>
                    <Box sx={{ display: 'flex', gap: '8px' }}>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV4
                                label='From'
                                option={(filterOpt?.fromCity?.length > 0 ? [{ FromCityID: 0, FromCityName: 'All' }, ...filterOpt?.fromCity] : []) || []}
                                primaryKey='FromCityID'
                                labelKey='FromCityName'
                                preSelectedValues={filterValue?.from || []}
                                onSelect={(val) => {
                                    handleFromCity(val)
                                }}
                                multiSelect={true}
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV4
                                label='To'
                                option={(filterOpt?.toCity?.length > 0 ? [{ ToCityID: 0, ToCityName: 'All' }, ...filterOpt?.toCity] : []) || []}
                                primaryKey='ToCityID'
                                labelKey='ToCityName'
                                preSelectedValues={filterValue?.to || []}
                                onSelect={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        to: val
                                    }))
                                    resetTableData()
                                }}
                                multiSelect={true}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px' }}>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV4
                                label='Fare Type'
                                // option={filterOpt?.fareType || []}
                                option={(filterOpt?.fareType?.length > 1 ? [{ id: 0, name: 'All' }, ...filterOpt?.fareType] : filterOpt?.fareType) || []}
                                primaryKey='id'
                                labelKey='name'
                                preSelectedValues={filterValue?.fareType || []}
                                onSelect={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        fareType: val
                                    }))
                                    resetTableData()
                                }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flex: 1 }}>
                            <Box className='charDatePicker'>
                                <CustomDatePicker
                                    selectedDate={filterValue?.ChartDate}
                                    label='Chart Date'
                                    format='DD-MMM-YYYY'
                                    iconsPosition='end'
                                    onChange={(val) => {
                                        setFilterValue((prev) => ({
                                            ...prev,
                                            ChartDate: val,
                                            StartDate: val,
                                            endDate: val
                                        }))
                                        resetTableData()
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Box>
                            <Box className='arrowBtn' onClick={handleConfiguredDetails}>
                                <KeyboardArrowRightIcon />
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box className='filter-middle'>
                    <Box sx={{ display: 'flex', gap: '8px', paddingX: '16px' }}>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV4
                                label='Hrs'
                                option={hrList || []}
                                primaryKey='id'
                                labelKey='name'
                                preSelectedValues={filterValue?.hrs || []}
                                onSelect={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        hrs: val
                                    }))
                                }}
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV4
                                label='Min'
                                option={minList || []}
                                primaryKey='id'
                                labelKey='name'
                                preSelectedValues={filterValue?.min || []}
                                onSelect={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        min: val
                                    }))
                                }}
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV4
                                label='AM/PM'
                                option={amPmTypeList || []}
                                primaryKey='id'
                                labelKey='name'
                                preSelectedValues={filterValue?.amPm || []}
                                onSelect={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        amPm: val
                                    }))
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
                <Box className='filter-middle'>

                    <Box sx={{ display: 'flex', gap: '8px', paddingX: '16px' }}>
                        <Box sx={{ flex: 1 }} className='charDatePicker'>
                            <CustomDatePicker
                                selectedDate={filterValue?.StartDate}
                                disabled={true}
                                label='Start Date'
                                format='DD-MMM-YYYY'
                                iconsPosition='end'
                                onChange={(val) => {
                                    if (new Date(val) < new Date(filterValue.endDate)) {
                                        setFilterValue({ ...filterValue, StartDate: val })
                                    } else {
                                        setFilterValue({ ...filterValue, StartDate: val, endDate: val })
                                    }
                                }}
                                style={{ width: '100%' }}
                            />
                        </Box>
                        <Box sx={{ flex: 1 }} className='charDatePicker'>
                            <CustomDatePicker
                                selectedDate={filterValue.endDate}
                                label='End Date'
                                format='DD-MMM-YYYY'
                                iconsPosition='end'
                                minDate={filterValue?.StartDate}
                                onChange={(val) => {
                                    setFilterValue({ ...filterValue, endDate: val })
                                }}
                                style={{ width: '100%' }}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '8px', paddingX: '16px' }}>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV4
                                label='Amenities'
                                option={amenitiesList || []}
                                primaryKey='AmenitiesTypeID'
                                labelKey='AmenitiesType'
                                preSelectedValues={filterValue?.amenities || []}
                                multiSelect={true}
                                onSelect={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        amenities: val
                                    }))
                                }}
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV4
                                label='Runs'
                                option={runOptList || []}
                                primaryKey='value'
                                labelKey='name'
                                preSelectedValues={filterValue?.runs || []}
                                onSelect={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        runs: val
                                    }))
                                }}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ padding: '0px 16px 0px 25px', borderBottom: '1px solid #bababa', backgroundColor: '#EDF7FF' }}>
                        {
                            (filterValue?.runs?.[0]?.value === 3 && weeklyList?.length > 0) && (
                                <Box sx={{
                                    display: 'flex', flexWrap: 'wrap',
                                }}>
                                    {weeklyList.map((obj) => (
                                        <Box width={'65px'} sx={{ paddingY: '4px' }}>
                                            <FormControlLabel
                                                sx={{
                                                    '& .MuiTypography-root': {
                                                        fontSize: '12px !important',
                                                    },
                                                    '& .MuiCheckbox-root': {
                                                        padding: '0 2px 0 0 !important'
                                                    },
                                                    '& .Mui-checked': { color: '#ff6100 !important' },
                                                }}
                                                control={
                                                    <Checkbox
                                                        checked={filterValue?.[obj.field]}
                                                        onChange={(e) => {
                                                            setFilterValue((prev) => ({
                                                                ...prev,
                                                                [obj.field]: e.target.checked
                                                            }))
                                                        }}
                                                        color="primary"
                                                    />
                                                }
                                                label={obj.name}
                                            />
                                        </Box>
                                    ))}
                                </Box>
                            )
                        }
                    </Box>
                    <Box sx={{ display: 'flex', paddingLeft: '10px', width: '100%', justifyContent: 'space-between', padding: '0px 16px 0px 28px' }}>
                        {checkList.map((obj) => (
                            <FormControlLabel
                                sx={{
                                    '& .MuiTypography-root': {
                                        fontSize: '12px !important',
                                        color: '#1A1A1A'
                                    },
                                    '& .MuiCheckbox-root': {
                                        padding: '0 4px 0 0 !important',
                                        width: '22px',
                                        height: '22px'
                                    },
                                    '& .Mui-checked': { color: '#ff6100 !important' },
                                }}
                                control={
                                    <Checkbox
                                        checked={filterValue?.[obj.field]}
                                        onChange={(e) => {
                                            setFilterValue((prev) => ({
                                                ...prev,
                                                [obj.field]: e.target.checked
                                            }))
                                        }}
                                        color="primary"
                                    />
                                }
                                label={obj.name}
                            />
                        ))}

                    </Box>

                </Box>
                <Box
                    className="filter-bottom"
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "flex-start",
                        gap: 1,
                    }}
                >
                    <Box sx={{ flex: 0.8 }}>
                        <DropDownV4
                            label="Value Type"
                            option={ValueTypeOpt || []}
                            primaryKey="id"
                            labelKey="name"
                            preSelectedValues={filterValue?.valueType || []}
                            onSelect={(val) => {
                                setFilterValue((prev) => ({
                                    ...prev,
                                    valueType: val,
                                    autoIncrease:
                                        val?.[0]?.id === 0
                                            ? [autoIncreaseForAmtOpt[0]]
                                            : [autoIncreaseForPreOpt[0]],
                                }));
                            }}
                        />
                    </Box>
                    <Box sx={{ flex: 0.8 }}>
                        <DropDownV4
                            label="Auto Increase"
                            option={
                                filterValue?.valueType?.[0]?.id === 0
                                    ? autoIncreaseForAmtOpt
                                    : autoIncreaseForPreOpt
                            }
                            primaryKey="id"
                            labelKey="name"
                            preSelectedValues={filterValue?.autoIncrease || []}
                            onSelect={(val) => {
                                setFilterValue((prev) => ({ ...prev, autoIncrease: val }));
                            }}
                        />
                    </Box>
                    {fares.length > 0 && (
                        <Box
                            key={fares.length}
                            sx={{
                                flex: many ? "1 1 100%" : 1.0,
                                display: "flex",
                                gap: "4px",
                                mt: many ? 1 : 0,
                            }}
                        >
                            <Box
                                className="inputField"
                                sx={{
                                    display: many ? "flex" : "block",
                                    flex: 1,
                                    gap: many ? 2 : 0,
                                }}
                            >
                                {fares.map((fare) => (
                                    <TextBoxPlain
                                        key={fare.id}
                                        label={`${fare.name}`}
                                        type="number"
                                        value={filterValue?.amount?.[fare.id] || ""}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setFilterValue((prev) => ({
                                                ...prev,
                                                amount: {
                                                    ...(prev.amount || {}),
                                                    [fare.id]: val,
                                                },
                                            }));
                                        }}
                                        style={{
                                            flex: many ? "1" : "unset",
                                        }}
                                    />
                                ))}
                            </Box>
                            <Box className="arrowBtn" onClick={handleAutoIncrease}>
                                <KeyboardArrowRightIcon />
                            </Box>
                        </Box>
                    )}
                </Box>
                <Box >
                    <TableContainer component={Paper} sx={{ minWidth: '100%', boxShadow: '0px 1px 3px 0px #00000026' }}>
                        <Table
                            stickyHeader
                            size="small"
                            aria-label="Quota Table"
                            sx={{
                                '& .MuiTableCell-root': {
                                    padding: '8px 16px'
                                },
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    {tableCol.map((col, index) => (
                                        <TableCell
                                            key={`seatWise-Header-${index}`}
                                            sx={{
                                                ...col.style,
                                                fontSize: '12px',
                                                color: '#000000',
                                                fontWeight: '600',
                                                whiteSpace: 'pre-line'
                                            }}
                                        >
                                            {col.headerName}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData?.edit?.length !== 0 ? (
                                    tableData.edit.map((obj, index) => (
                                        <TableRow key={`row-${index}`} sx={{ paddingX: '0px' }}>
                                            {tableCol.map((col, colIndex) => (
                                                <TableCell
                                                    key={`cell-${index}-${colIndex}`}
                                                    sx={{
                                                        ...col.style,
                                                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                                                        "& .MuiOutlinedInput-root": {
                                                            height: "24px",
                                                        },
                                                    }}
                                                >
                                                    {col.field === 'FromCityName' || col.field === 'ToCityName' ? (
                                                        obj[col.field] || ''
                                                    ) : (
                                                        <TextBox
                                                            value={obj[col.field] || ""}
                                                            type="number"
                                                            onChange={(event) => {
                                                                handleFareAmount(
                                                                    obj.FromCityID,
                                                                    obj.ToCityID,
                                                                    col.field,
                                                                    event.target.value
                                                                );
                                                            }}
                                                            style={{ fontSize: "12px" }}
                                                        />
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={tableCol.length} sx={{ textAlign: 'center' }}>
                                            No Record
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
            <Box sx={{
                position: 'fixed', bottom: '0px', left: '0px', right: '0px', padding: '12px 16px',
                boxShadow: '1px 0px 3px 0px #00000040',
                backgroundColor: '#fff'
            }}>
                <MButton
                    disabled={tableData?.edit?.length === 0 && tableData?.origin?.length === 0}
                    btnName='schedule trip'
                    onClick={handleScheduleTrip}
                />
            </Box>
        </Box>
    )
}

export default TripSchedule